import { createSlice } from "@reduxjs/toolkit"
import { cartAction, updatePayment, driveImageDownload, imageURLDbUpload, getPaidList, uploadProfileImage } from './cartAction';

const initialState = {
  loading: false,
  bankDataLoading: false,
  success: false,
  data: {
    slip_name: '',
    date: '',
  },
  bankData: {},
  showImageStore: [],
  dbStoreImage: [],
  dbImageUrl: {},
  paidUserList: [],
  profileImageData: null,
  imageCache: {} // Cache images by userId: { userId: [imageData], ... }
}


const cartSlice = createSlice({
  name: 'cartDetails',
  initialState,
  reducers: {
    setBankSlip: (state, { payload }) => {
      state.data = payload
    },
    setBankDetails: (state, { payload }) => {
      state.bankData = payload
    },
    showImageStore: (state, action) => {
      if (action.payload === "clear") {
        state.showImageStore = [];  // Reset array
      } else {
        state.showImageStore.push(action.payload);
      }
    },
    resetCart: (state) => {
      state.data = { slip_name: '', date: '' };
      state.showImageStore = [];
      state.bankData = {};
      state.success = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(cartAction.pending, (state) => {
        state.bankDataLoading = true;
        state.success = false;
      })
      .addCase(cartAction.fulfilled, (state, action) => {
        state.bankDataLoading = false;
        state.success = true;
        state.bankData = action.payload;
      })
      .addCase(cartAction.rejected, (state, action) => {
        state.bankDataLoading = false;
        state.success = false;
        state.error = action.payload;
      })
      .addCase(updatePayment.pending, (state) => {
        state.bankDataLoading = true;
        state.success = false;
      })
      .addCase(updatePayment.fulfilled, (state, action) => {
        state.bankDataLoading = false;
        state.success = true;
        state.bankData = action.payload;
      })
      .addCase(updatePayment.rejected, (state, action) => {
        state.bankDataLoading = false;
        state.success = false;
        state.error = action.payload;
      })
      .addCase(driveImageDownload.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(driveImageDownload.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.dbStoreImage = action.payload;
      })
      .addCase(driveImageDownload.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = true;
      })
      .addCase(imageURLDbUpload.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(imageURLDbUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.dbImageUrl = action.payload;
      })
      .addCase(imageURLDbUpload.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = true;
        state.dbImageUrl = action.payload;
      })
      .addCase(getPaidList.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(getPaidList.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.paidUserList = action.payload;
      })
      .addCase(getPaidList.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = true;
        state.paidUserList = action.payload;
      })
      .addCase(uploadProfileImage.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(uploadProfileImage.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.profileImageData = action.payload;
      })
      .addCase(uploadProfileImage.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = true;
        state.profileImageData = action.payload;
      })
  }
})
export const { setBankSlip, setBankDetails, showImageStore, resetCart } = cartSlice.actions

export default cartSlice.reducer
